import { ENV } from '../constants/environments';
import {
    UBI_EVENTS_ENDPOINT,
    UBI_SERVICES_ENDPOINT,
    FRIENDS_REFERRAL_ENDPOINT,
    UPLAY_CLIENT_ENDPOINT,
    Regions
} from '../constants/ubi-services.constants';

export const getEnvDependentEndpoint = ({
    envName,
    source,
    countryCode
}: {
    envName: string,
    source: Object,
    countryCode?: string
}): string => {
    let instance = envName;

    if (isProd(envName)) {
        instance = ENV.PROD; // should use stable instance of API services on PROD & PREPROD
    }

    if (countryCode) {
        const region = checkRegions(countryCode);
        return source[region][instance] || source[region][ENV.DEV];
    }

    return source[instance] || source[ENV.DEV];
};

export const getUbiServicesEndpoint = (envName: string): string => {
    return getEnvDependentEndpoint({ envName, source: UBI_SERVICES_ENDPOINT });
};

export const getUbiEventsEndpoint = (envName: string): string => {
    return getEnvDependentEndpoint({ envName, source: UBI_EVENTS_ENDPOINT });
};

export const getFriendsReferralEndpoint = (envName: string): string => {
    return getEnvDependentEndpoint({ envName, source: FRIENDS_REFERRAL_ENDPOINT });
};

export const getUplayClientEndpoint = (envName: string, countryCode: string): string => {
    return getEnvDependentEndpoint({ envName, countryCode, source: UPLAY_CLIENT_ENDPOINT });
};

export function isProd(envName: string): boolean {
    const prodOptions = {
        [ENV.PROD]: ENV.PROD,
        [ENV.PREPROD]: ENV.PREPROD
    };

    return prodOptions[envName] ? true : false;
}

export const checkRegions = (countryCode: string) => {
    // check for china region
    if (countryCode === 'CN') {
        return Regions.CHINA;
    }

    return Regions.WORLD;
};
